(function () {
  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NGN'
      });
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function initSearch() {
    var root = document.querySelector('[data-wx-search]');
    var openBtns = document.querySelectorAll('[data-wx-search-open]');
    if (!root || !openBtns.length || root.dataset.wxSearchReady === '1') return;
    root.dataset.wxSearchReady = '1';

    var input = root.querySelector('[data-wx-search-input]');
    var defaultPane = root.querySelector('[data-wx-search-default]');
    var livePane = root.querySelector('[data-wx-search-live]');
    var results = root.querySelector('[data-wx-search-results]');
    var allLink = root.querySelector('[data-wx-search-all]');
    var closers = root.querySelectorAll('[data-wx-search-close]');
    var timer = null;
    var lastFocus = null;

    function openSearch() {
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add('wx-search-open');
      if (input) {
        input.value = '';
        input.focus();
      }
      showDefault();
    }

    function closeSearch() {
      root.hidden = true;
      document.body.classList.remove('wx-search-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function showDefault() {
      if (defaultPane) defaultPane.classList.remove('is-hidden');
      if (livePane) livePane.classList.add('is-hidden');
    }

    function showLive() {
      if (defaultPane) defaultPane.classList.add('is-hidden');
      if (livePane) livePane.classList.remove('is-hidden');
    }

    function renderProducts(products) {
      if (!results) return;
      if (!products || !products.length) {
        results.innerHTML = '<p class="wx-search__empty">No products found.</p>';
        return;
      }

      results.innerHTML = products
        .map(function (p) {
          var img =
            p.image ||
            (p.featured_image && (p.featured_image.url || p.featured_image)) ||
            '';
          var price = typeof p.price === 'number' ? money(p.price) : p.price || '';
          var type = p.type || p.product_type || '';
          var badge = (p.tags || []).some(function (t) {
            return String(t).toLowerCase() === 'new';
          })
            ? '<span class="wx-search__badge">New</span>'
            : '';

          return (
            '<a class="wx-search__card" href="' +
            p.url +
            '">' +
            '<div class="wx-search__card-media">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            badge +
            '</div>' +
            '<div class="wx-search__card-info">' +
            (type ? '<p class="wx-search__card-type">' + type + '</p>' : '') +
            '<h4 class="wx-search__card-title">' +
            p.title +
            '</h4>' +
            '<p class="wx-search__card-price">' +
            price +
            '</p>' +
            '</div></a>'
          );
        })
        .join('');
    }

    function runPredictive(q) {
      if (!q || q.length < 2) {
        showDefault();
        return;
      }

      if (allLink) {
        allLink.href = (window.routes && window.routes.search_url ? window.routes.search_url : '/search') + '?q=' + encodeURIComponent(q) + '&type=product';
      }

      var url =
        (window.routes && window.routes.predictive_search_url
          ? window.routes.predictive_search_url
          : '/search/suggest') +
        '?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';

      // Prefer JSON suggest endpoint
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var products =
            (data.resources && data.resources.results && data.resources.results.products) ||
            (data.resources && data.resources.products) ||
            [];
          showLive();
          renderProducts(products);
        })
        .catch(function () {
          showLive();
          renderProducts([]);
        });
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });

    closers.forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) closeSearch();
    });

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () {
          runPredictive(q);
        }, 220);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else {
    initSearch();
  }

  document.addEventListener('shopify:section:load', function () {
    var root = document.querySelector('[data-wx-search]');
    if (root) delete root.dataset.wxSearchReady;
    initSearch();
  });
})();
